import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import { Helmet } from "react-helmet";

import NavbarB from "../components/navbar-b";
import FooterB from "../components/footer-b";
import "./home.css";

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>Feelers Season 2026</title>
        <meta property="og:title" content="FF Season 2026" />
        <link rel="canonical" href="https://feelers-feelers.com" />
      </Helmet>
      <div className="home-bg-container">
        <img
          alt="image"
          src="/machineyearning/MY-main-bg.jpg"
          className="home-image-bg"
        />
      </div>
      <div className="home-navbar-container">
        <NavbarB rootClassName="navbar-broot-class-name1"></NavbarB>
      </div>
      <div className="home-landing">
        <img
          src="/machineyearning/MY-home-desktop.webp"
          className="home-land-img-d"
        />
        <img
          src="/machineyearning/MY-home-mobile.webp"
          className="home-land-img-m"
        />
        <img
          src="/machineyearning/MY-title-desktop.gif"
          className="home-title-img-d"
        />
        <img
          src="/machineyearning/MY-title-mobile.gif"
          className="home-title-img-m"
        />
      </div>
      <div className="home-body">
        <div className="home-thq-navbar-my-container-elm">
          <div className="home-thq-navbar-hori-elm">
            <div className="home-thq-buttons-elm">
              <a href="#intro" className="home-thq-intro-elm1 button">
                <span className="home-text100 MY-Body">INTRO</span>
              </a>
              <a href="#editorial" className="home-thq-editorial-elm1 button">
                <span className="home-text101 MY-Body">EDITORIAL</span>
              </a>
              <a
                href="#hackingdesire"
                className="home-thq-editorial-elm1 button"
              >
                <span className="home-text101 MY-Body">HACKING DESIRE</span>
              </a>
              <a href="#micro" className="home-thq-micro-residency-elm1 button">
                <span className="home-text102 MY-Body">MICRO-RESIDENCY</span>
              </a>
              <button className="home-thq-programs-elm button">
                <a href="#program" className="home-link10 MY-Body">
                  PROGRAMS
                </a>
              </button>
              <button className="home-thq-calendar-elm1 button">
                <a href="#calendar" className="home-link11 MY-Body">
                  CALENDAR
                </a>
              </button>
            </div>
          </div>
          <div className="home-thq-navbar-vert-elm">
            <div
              data-thq="thq-dropdown"
              className="home-thq-dropdown list-item"
            >
              <div
                data-thq="thq-dropdown-toggle"
                className="home-thq-dropdown-toggle-elm1"
              >
                <span className="MY-Subtitle">MENU</span>
              </div>
              <ul
                data-thq="thq-dropdown-list"
                className="home-thq-dropdown-list-elm"
              >
                <a href="#intro" data-thq="thq-dropdown">
                  <li className="home-thq-dropdown-elm1 list-item">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="home-thq-dropdown-toggle-elm2"
                    >
                      <span className="MY-Subtitle">INTRO</span>
                    </div>
                  </li>
                </a>
                <a href="#editorial" data-thq="thq-dropdown">
                  <li className="home-thq-dropdown-elm2 list-item">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="home-thq-dropdown-toggle-elm3"
                    >
                      <span className="MY-Subtitle">EDITORIAL</span>
                    </div>
                  </li>
                </a>
                <a href="#hackingdesire" data-thq="thq-dropdown">
                  <li className="home-thq-dropdown-elm2 list-item">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="home-thq-dropdown-toggle-elm3"
                    >
                      <span className="MY-Subtitle">HACKING DESIRE</span>
                    </div>
                  </li>
                </a>
                <a href="#micro" data-thq="thq-dropdown">
                  <li className="home-thq-dropdown-elm3 list-item">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="home-thq-dropdown-toggle-elm4"
                    >
                      <span className="MY-Subtitle">MICRO-RESIDENCY</span>
                    </div>
                  </li>
                </a>
                <a href="#program" data-thq="thq-dropdown">
                  <li className="home-thq-dropdown-elm4 list-item">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="home-thq-dropdown-toggle-elm5"
                    >
                      <span className="MY-Subtitle">PROGRAMS</span>
                    </div>
                  </li>
                </a>
                <a href="#calendar" data-thq="thq-dropdown">
                  <li className="home-thq-dropdown-elm5 list-item">
                    <div
                      data-thq="thq-dropdown-toggle"
                      className="home-thq-dropdown-toggle-elm6"
                    >
                      <span className="MY-Subtitle">CALENDAR</span>
                    </div>
                  </li>
                </a>
              </ul>
            </div>
          </div>
        </div>
        <div id="intro" className="home-thq-intro-elm2">
          <div className="home-thq-intro-bg-elm1">
            <img
              alt="image"
              src="/machineyearning/l_d_01.webp"
              loading="eager"
              className="home-image6"
            />
            <img
              alt="image"
              src="/machineyearning/l_d_02.webp"
              loading="eager"
              className="home-thq-image-elm10"
            />
          </div>
          <div className="home-thq-intro-body-elm">
            <span className="home-text109 MY-Headline">
              What do our technologies want from us, and what do we want from
              them?
            </span>
            <span className="home-text110 MY-Body">
              <span>
                Machine Yearning is Feelers third Season of programmes, an
                annual series of interdisciplinary programmes that flow along
                circuits and fault lines between art and technology. 
              </span>

              <br className="home-text112"></br>
              <span>
                This year, we turn toward the entanglements of desire and
                technology, examining how our attachments are made familiar and
                strange by our machines. We look underneath behaviour influenced
                by algorithmic persuasion to embrace quieter ways of wanting. 
              </span>
              <br className="home-text115"></br>
              <br className="home-text116"></br>
              <span>
                Turning away from questions of intelligence, we lean toward the
                instincts immanent in what we crave: both that which is taut and
                urgent, and that which is shapeless and inchoate. Amidst the
                contemporary turn toward affective computation, we explore how
                our technologies mediate, collide with, amplify, and script
                desiring. Where might we arrive if we follow the uncanny pull of
                our collective longings?
              </span>
            </span>
            <Link to="/intro" className="home-text118 MY-Body">
              <span> READ FULL INTRO &gt; </span>
              <br></br>
            </Link>
          </div>
          <div className="home-thq-intro-bg-elm2">
            <img
              alt="image"
              src="/machineyearning/l_d_02.webp"
              loading="eager"
              className="home-thq-image-elm11"
            />
          </div>
        </div>
        <div id="editorial" className="home-thq-editorial-elm2">
          <div className="home-thq-editorial-bg-elm">
            <img
              alt="image"
              src="/machineyearning/l_d_03.webp"
              loading="eager"
              className="home-image7"
            />
          </div>
          <div className="home-thq-editorial-body-elm">
            <div className="home-thq-ed-row1-elm">
              <span className="home-text121 MY-FancyTitle">Editorial</span>
              <div className="home-thq-ed-col-r-elm">
                <span className="MY-Body">
                  <b>LIFE IN THE WAKE</b>
                </span>
                <span className="MY-Body">
                  <span className="home-text124 MY-Body">
                    A worldview produces technology. A technology in return
                    produces a worldview. A recursive loop. How might one break
                    a loop for a new life code – break the worldview or break
                    the tool?
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                  <br className="home-text125 MY-Body"></br>
                  <br className="home-text126 MY-Body"></br>
                  <span className="home-text127 MY-Body">
                    In October, crossing time zones between Cambridge, USA and
                    Lagos, Nigeria, artist and writer
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                  <a
                    href="https://www.instagram.com/oneirocritica/?hl=en"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="ppl-link"
                  >
                    Luca E. Lum
                  </a>
                  <span className="home-text128 MY-Body">
                    {" "}
                    and artist, designer, and creative technologist{" "}
                  </span>
                  <a
                    href="https://uzomaorji.com/"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="ppl-link"
                  >
                    Uzoma Orji
                  </a>
                  <span>
                    {" "}
                    discuss artistic production, continuity, colonial mirroring,
                    paucity and plenty, and desiring in the wake of assumed
                    value.
                  </span>
                </span>
              </div>
            </div>
            <Link to="/editorial" className="home-navlink1 MY-Body">
              <span> READ FULL EDITORIAL &gt; </span>
              <br></br>
            </Link>
          </div>
        </div>
        <div id="hackingdesire" className="home-thq-editorial-elm2">
          <div className="home-thq-editorial-bg-elm">
            <img
              alt="image"
              src="/machineyearning/l_d_03.webp"
              loading="eager"
              className="home-image7"
            />
          </div>
          <div className="home-thq-hackingdesire-body-elm">
            <div className="home-thq-ed-row1-elm">
              <span className="home-text121 MY-FancyTitle">Hacking Desire</span>
              <div className="home-thq-ed-col-r-elm">
                <span className="MY-Body">
                  <b>HACKING DESIRE</b>
                </span>
                <span className="MY-Body">
                  <span className="home-text124 MY-Body">
                    In this annotated interview, repair technician Ada Adhiyatma
                    wonders about the structure of desire and how it interlaces
                    with disability. In conversation with disability justice
                    writer{" "}
                    <a
                      href="https://brownstargirl.org/"
                      target="_blank"
                      className="ppl-link"
                    >
                      Leah Lakshmi Piepzna-Samarasinha
                    </a>
                    , they delve into the idea of “disability access” as
                    friction, and ask if our technological solutionism masks a
                    disabled relationship to technology that contains at its
                    heart a wild capacity for yearning, pleasure, and fantasy.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                  <br className="home-text125 MY-Body"></br>
                  <br className="home-text126 MY-Body"></br>
                </span>
              </div>
            </div>
            <Link to="/hackingdesire/start" className="home-navlink1 MY-Body">
              <span> READ FULL INTERVIEW &gt; </span>
              <br></br>
            </Link>
          </div>
        </div>

        <div id="micro" className="home-thq-micro-residency-elm2">
          <div className="home-thq-micro-bg-elm">
            <img
              alt="image"
              src="/machineyearning/l_d_04.webp"
              loading="eager"
              className="home-thq-image-elm12"
            />
          </div>
          <div className="home-thq-micro-body-elm">
            <span className="home-text131 MY-Headline">
              THIS YEAR&apos;S EVENTS
            </span>
            <span className="home-text132 MY-Subtitle">SEASON SPECIAL</span>
            <span className="home-text133 MY-FancyTitle">Micro-Re$idency</span>
            <div className="home-thq-micro-row4-elm">
              <div className="home-thq-mr-row4l-elm"></div>
              <div className="home-thq-mr-row4r-elm">
                <span className="home-text134 MY-Body">
                  <span className="MY-Body">
                    The Micro-Residency invites creative practitioners from all
                    disciplines to engage in an intensive short-term residency
                    exploring the theme Machine Yearning.
                  </span>
                  <br className="MY-Body"></br>
                  <br className="MY-Body"></br>
                  <span className="MY-Body">
                    For 2026, our invited artists are
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                  <a
                    href="https://fawn-world.com/"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="ppl-link"
                  >
                    Fawn World
                  </a>
                  <span className="MY-Body">
                    {" "}
                    x
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                  <a
                    href="https://hansclayground.com/"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="ppl-link"
                  >
                    Hans Chew
                  </a>
                  <span className="MY-Body">
                    , and
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                  <a
                    href="https://www.instagram.com/soniakwek/?hl=en"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="ppl-link"
                  >
                    Sonia Kwek
                  </a>
                  <span className="MY-Body">.</span>
                </span>
                <Link to="/micro-residency" className="home-navlink2 MY-Body">
                  <span> READ MORE &gt; </span>
                  <br></br>
                </Link>
              </div>
            </div>
            <div className="home-thq-micro-row5-elm">
              <div className="home-thq-mr-row5l-elm">
                <span className="home-text144 MY-Body">28 March</span>
                <span className="home-text145 MY-Body">2pm – 5pm</span>
              </div>
              <div className="home-thq-mr-row5r-elm">
                <span className="MY-Subtitle">SHARING SESSION</span>
                <span className="MY-Body">
                  As part of the program <i>Making Room</i>,
                  artists-in-residence Sonia Kwek, Hans Chew and Fawn World will
                  share ongoing research undertaken during the residency, in
                  dialogue with the practice of Genevieve Ong, a community
                  builder at Forest School Singapore.
                </span>
                <span className="home-text148 MY-Body">
                  <span> REGISTER </span>
                  <br></br>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div id="program" className="home-thq-program-elm">
          <div className="home-thq-p-bg-elm">
            <img
              alt="image"
              src="/machineyearning/l_d_05.webp"
              loading="eager"
              className="home-thq-image-elm13"
            />
            <img
              alt="image"
              src="/machineyearning/l_d_06.webp"
              loading="eager"
              className="home-thq-image-elm14"
            />
            <img
              alt="image"
              src="/machineyearning/l_d_07.webp"
              loading="eager"
              className="home-thq-image-elm15"
            />
          </div>
          <div className="p-body">
            <span className="home-text151 MY-Subtitle">PROGRAM 1</span>
            <span className="home-text152 MY-FancyTitle">
              Open Studio Se$$ion$
            </span>
            <div className="p-row">
              <div className="p-rowL">
                <span className="MY-Body">
                  <b>5, 6, 12, 13, 19, 20, 26, 27 March</b>
                </span>
                <span className="MY-Body">
                  <b>12pm – 6pm</b>
                </span>
              </div>
              <div className="p-rowR">
                <span className="MY-Body">
                  <span className="MY-Body">
                    Our Open Studio sessions offer a glimpse into the creative
                    processes of Feelers and our artists-in-residence.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                  <br className="MY-Body"></br>
                  <br className="MY-Body"></br>
                  <span className="MY-Body">
                    Visitors are welcome to co-work alongside us, encounter
                    works in progress, observe the research processes shaping
                    them, and spend time with texts from our collective open
                    library.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    Open Studio sessions are a space for shared attention — an
                    invitation to witness, reflect, and inhabit the rhythms of
                    making as it unfolds.
                  </span>
                  <br></br>
                </span>
                <span className="home-text164 MY-Body">
                  <span> REGISTER </span>
                  <br></br>
                </span>
              </div>
            </div>
          </div>
          <div className="p-body">
            <span className="home-text167 MY-Subtitle">PROGRAM 2</span>
            <span className="home-text168 MY-FancyTitle">Look Smart</span>
            <div className="p-row">
              <div className="p-rowL">
                <span className="MY-Body">
                  <b>14 March</b>
                </span>
                <span className="MY-Body">
                  <b>4pm – 7pm</b>
                </span>
              </div>
              <div className="p-rowR">
                <span className="MY-Body">
                  <span>
                    Look Smart is a walk-and-talk at Punggol Digital District
                    (PDD) exploring how urban development codifies and
                    reinforces the desires of residents.
                    <br></br>
                    <br></br>
                    As “Singapore’s first smart urban grid”, “a living lab”, and
                    “Singapore’s take on Silicon Valley”, PDD is a testing
                    ground for the state's desires and assumptions.
                    <br></br>
                    <br></br>
                    Led by architectural designers John Chew Geronimo Jr and
                    Joshua Ng, this experience will take us through the District
                    as we uncover the histories and industrial forces that
                    shaped Punggol, and mapping the systems and technologies
                    creating its future.
                  </span>
                </span>
                <a
                  href="https://forms.gle/aQncc3uNgFCxuKsWA"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="home-link21 MY-Body"
                >
                  <span> REGISTER </span>
                  <br></br>
                </a>
              </div>
            </div>
          </div>
          <div className="p-body">
            <span className="home-text181 MY-Subtitle">PROGRAM 3</span>
            <span className="home-text182 MY-FancyTitle">Did you mean:</span>
            <div className="p-row">
              <div className="p-rowL">
                <span className="MY-Body">
                  <b>19 March</b>
                </span>
                <span className="MY-Body">
                  <b>7pm – 10pm</b>
                </span>
              </div>
              <div className="p-rowR">
                <span className="MY-Body">
                  <span>
                    Weaving dialogue, storytelling, and audience interaction to
                    explore how knowledge is organised, monetised, and
                    delivered, Did you mean: asks what it now means to ask, and
                    to be answered.
                  </span>
                  <br className="MY-Body"></br>
                  <br className="MY-Body"></br>
                  <span>
                    Two performers trace our relationship with search, from
                    childhood questions and awkward memories to Google, data
                    centres, and AI.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                  <br className="MY-Body"></br>
                  <br className="MY-Body"></br>
                  <span>
                    This conversational performance moves between humour,
                    memory, philosophy of technology, and cultural critique to
                    examine search as a deeply human act. For anyone who has
                    ever typed a question and hoped for resolution rather than a
                    result.
                  </span>
                </span>
                <span className="home-text193 MY-Body">
                  <span> REGISTER </span>
                  <br></br>
                </span>
              </div>
            </div>
          </div>

          <div className="p-body">
            <span className="home-text210 MY-Subtitle">
              CLOSING PANEL DISCUSSION
            </span>
            <span className="home-text211 MY-FancyTitle">Making Room</span>
            <div className="p-row">
              <div className="p-rowL">
                <span className="MY-Body">
                  <b>28 March</b>
                </span>
                <span className="MY-Body">
                  <b>2pm – 5pm</b>
                </span>
              </div>
              <div className="p-rowR">
                <span className="MY-Body">
                  <span>
                    Making Room closes our 2026 season with an intimate
                    gathering facilitated by{" "}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                  <a
                    href="https://www.instagram.com/snat.ty"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="ppl-link"
                  >
                    Natalie Sutanto
                  </a>
                  <span>
                    .
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                  <br className="MY-Body"></br>
                  <br className="MY-Body"></br>
                  <span>
                    Artists-in-residence Sonia Kwek, Hans Chew and Fawn World
                    will share ongoing research undertaken during the residency,
                    in dialogue with the practice of Genevieve Ong, a community
                    builder at Forest School Singapore.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " ",
                      }}
                    />
                  </span>
                  <br className="MY-Body"></br>
                  <br className="MY-Body"></br>
                  <span>
                    Emerging from How To Go On, Feelers’ ongoing research into
                    the quiet work of how to sustain ourselves, our creative
                    practices, and each other, we open a shared inquiry into how
                    we might make room enough to dream.
                  </span>
                  <br className="MY-Body"></br>
                  <br className="MY-Body"></br>
                  <span>
                    We welcome artists, educators, community workers, and anyone
                    curious about practices of spaceholding, placemaking, and
                    making-in-place.
                  </span>
                </span>
                <a
                  href="https://forms.gle/BRJ9ktL3T4jHHRK77"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="home-link22 MY-Body"
                >
                  <span> REGISTER </span>
                  <br></br>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div id="calendar" className="home-thq-calendar-elm2">
          <div className="home-thq-cal-bg-elm">
            <img
              alt="image"
              src="/machineyearning/l_d_08.webp"
              loading="eager"
              className="home-thq-image-elm16"
            />
          </div>
          <div className="home-thq-cal-body-elm">
            <span className="home-text227 MY-Headline">Season Calendar</span>
            <div className="home-thq-cal-row-elm10">
              <span className="home-text228 MY-Subtitle">05 MAR</span>
              <img
                alt="image"
                src="/machineyearning/vector%204.svg"
                loading="eager"
                className="home-thq-image-elm17"
              />
              <span className="home-text229 MY-Body">Open Studios</span>
              <span className="home-text230 MY-Subtitle">12 – 6PM</span>
            </div>
            <div className="home-thq-cal-row-elm10">
              <span className="home-text231 MY-Subtitle">06 MAR</span>
              <img
                alt="image"
                src="/machineyearning/vector%204.svg"
                loading="eager"
                className="home-thq-image-elm18"
              />
              <span className="home-text229 MY-Body">Open Studios</span>
              <span className="home-text233 MY-Subtitle">12 – 6PM</span>
            </div>
            <div className="home-thq-cal-row-elm10">
              <span className="home-text234 MY-Subtitle">12 MAR</span>
              <img
                alt="image"
                src="/machineyearning/vector%204.svg"
                loading="eager"
                className="home-thq-image-elm19"
              />
              <span className="home-text229 MY-Body">Open Studios</span>
              <span className="home-text236 MY-Subtitle">12 – 6PM</span>
            </div>
            <div className="home-thq-cal-row-elm10">
              <span className="home-text237 MY-Subtitle">13 MAR</span>
              <img
                alt="image"
                src="/machineyearning/vector%204.svg"
                loading="eager"
                className="home-thq-image-elm20"
              />
              <span className="home-text229 MY-Body">Open Studios</span>
              <span className="home-text239 MY-Subtitle">12 – 6PM</span>
            </div>
            <div className="home-thq-cal-row-elm10">
              <span className="home-text240 MY-Subtitle">14 MAR</span>
              <img
                alt="image"
                src="/machineyearning/vector%204.svg"
                loading="eager"
                className="home-thq-image-elm21"
              />
              <span className="home-text229 MY-Body">Look Smart</span>
              <span className="home-text242 MY-Subtitle">4 – 7PM</span>
            </div>
            <div className="home-thq-cal-row-elm15">
              <div className="home-thq-cal-row1-elm1">
                <span className="home-text243 MY-Subtitle">19 MAR</span>
                <img
                  alt="image"
                  src="/machineyearning/vector%204.svg"
                  loading="eager"
                  className="home-thq-image-elm22"
                />
                <span className="home-text229 MY-Body">Open Studios</span>
                <span className="home-text245 MY-Subtitle">12 – 6PM</span>
              </div>
              <div className="home-thq-cal-row1-elm2">
                <span className="home-text246 MY-Subtitle">19 MAR</span>
                <img
                  alt="image"
                  src="/machineyearning/vector%204.svg"
                  loading="eager"
                  className="home-thq-image-elm23"
                />
                <span className="home-text229 MY-Body">Did you mean:</span>
                <span className="home-text248 MY-Subtitle">7 – 10PM</span>
              </div>
            </div>
            <div className="home-thq-cal-row-elm10">
              <span className="home-text249 MY-Subtitle">20 MAR</span>
              <img
                alt="image"
                src="/machineyearning/vector%204.svg"
                loading="eager"
                className="home-thq-image-elm24"
              />
              <span className="home-text229 MY-Body">Open Studios</span>
              <span className="home-text251 MY-Subtitle">12 – 6PM</span>
            </div>
            <div className="home-thq-cal-row-elm10">
              <span className="home-text252 MY-Subtitle">21 MAR</span>
              <img
                alt="image"
                src="/machineyearning/vector%204.svg"
                loading="eager"
                className="home-thq-image-elm25"
              />
              <span className="home-text229 MY-Body">Hacking Desire</span>
              <span className="home-text254 MY-Subtitle">12 – 6PM</span>
            </div>
            <div className="home-thq-cal-row-elm10">
              <span className="home-text255 MY-Subtitle">26 MAR</span>
              <img
                alt="image"
                src="/machineyearning/vector%204.svg"
                loading="eager"
                className="home-thq-image-elm26"
              />
              <span className="home-text229 MY-Body">Open Studios</span>
              <span className="home-text257 MY-Subtitle">12 – 6PM</span>
            </div>
            <div className="home-thq-cal-row-elm10">
              <span className="home-text258 MY-Subtitle">27 MAR</span>
              <img
                alt="image"
                src="/machineyearning/vector%204.svg"
                loading="eager"
                className="home-thq-image-elm27"
              />
              <span className="home-text229 MY-Body">Open Studios</span>
              <span className="home-text260 MY-Subtitle">12 – 6PM</span>
            </div>
            <div className="home-thq-cal-row-elm10">
              <span className="home-text261 MY-Subtitle">28 MAR</span>
              <img
                alt="image"
                src="/machineyearning/vector%204.svg"
                loading="eager"
                className="home-thq-image-elm28"
              />
              <span className="home-text229 MY-Body">Making Room</span>
              <span className="home-text263 MY-Subtitle">2 – 5PM</span>
            </div>
          </div>
        </div>
      </div>
      <div className="home-thq-footer-container-elm">
        <FooterB
          link={
            <Fragment>
              <span className="home-text264">
                © 2026 by Feelers. All Rights Reserved. Feelers is a project housed under The Digit, which is part of Potato Productions.            </span>
            </Fragment>
          }
          link1={
            <Fragment>
              <span className="home-text265">
                More information about our Privacy Policy.
              </span>
            </Fragment>
          }
          rootClassName="footer-broot-class-name"
        ></FooterB>
      </div>
    </div>
  );
};

export default Home;
